module.exports = __webpack_public_path__ + "img/7.036a4b84.jpg";